import React from 'react';
import './styles/App.css';
import { Profile, SwitchContent, Contacts, Projects } from './components';
import { isMobile } from 'react-device-detect';
import { useTransition, animated } from 'react-spring';
import { useLocation, Route, Switch } from "react-router-dom";

function App() {

  if (isMobile) window.location.href = "https://arabank.netlify.com/";

  const location = useLocation()
  const transitions = useTransition(location, location => location.pathname, {
    from: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    leave: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
  })

  return (
    <div className="app p-3">
      {transitions.map(({ item, props, key }) => (
        <animated.div key={key} style={props}>
          <Switch location={item}>
            <Route exact path="/" render={() => <Profile />} />
            <Route path="/projects" render={() => <Projects />} />
            <Route path="/contacts" render={() => <Contacts />} />
          </Switch>
        </animated.div>
      ))}
      <SwitchContent />
    </div>
  );
}

export default App;
